// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fSAU","rootNoMargin":"styles_rootNoMargin__28Ssp"};